export enum CemCategory {
  Category1 = 'category1',
  Category2 = 'category2',
  Category3 = 'category3',
  Category4 = 'category4',
  Category5 = 'category5',
  Uncategorised = 'uncategorised',
}
